// extracted by mini-css-extract-plugin
module.exports = {"loader":"GtuoM55A9RBLmBFJvZq5","move":"_1OXfR8oOHs9aHeVbnZ3eCC"};